import { Link, useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import KPIProduitsService from "../../services/KPIProduitsService";
import { useLocation } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { Card, ListGroup, Nav, Form, Button, Tab, Col, Row, InputGroup } from 'react-bootstrap';
import CheckIcon from "@material-ui/icons/Check"; // Import CheckIcon if from Material UI
import { useParams } from 'react-router-dom';
import SocieteService from "../../services/Societe";

const navigationTitles = {
  "/KPIProduitsDetails/FAM": "Famille",
  "/KPIProduitsDetails/SUB_FAM": "Sous Famille",
  "/KPIProduitsDetails/CAT": "Catégorie",
  "/KPIProduitsDetails/BRAND": "Brand",
  "/KPIProduitsDetails/PACK": "Pack",
};

// Helper function to render tables for transfers
const renderTransferTable = (transfers, title) => (
  <section className="content">
    <div className="card mt-3">
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <div className="card-tools">
          <button type="button" className="btn btn-tool" data-card-widget="collapse" title="Collapse">
            <i className="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div className="card-body p-0">
        <table className="table projects">
          <thead>
            <tr className="text-center">
              <th style={{ width: "12%" }}>Libellé</th>
              <th style={{ width: "12%" }}>Commande</th>
              <th style={{ width: "12%" }}>Quantité Totale</th>
              <th style={{ width: "12%" }}>Prix initial</th>
              <th style={{ width: "12%" }}>Prix de vente</th>
            </tr>
          </thead>
          <tbody>
            {transfers.map((element) => (
              <tr className="text-center" key={element.id}>
                <td>{element.name}</td>
                <td>{element.count}</td>
                <td>{element.total_quantity}</td>
                <td>{element.totalAmountInitialPrice}</td>
                <td>{element.totalAmountSellingPrice}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);
// Define months options
const monthsOptions = [
  { label: "Janvier", value: 1 },
  { label: "Février", value: 2 },
  { label: "Mars", value: 3 },
  { label: "Avril", value: 4 },
  { label: "Mai", value: 5 },
  { label: "Juin", value: 6 },
  { label: "Juillet", value: 7 },
  { label: "Août", value: 8 },
  { label: "Septembre", value: 9 },
  { label: "Octobre", value: 10 },
  { label: "Novembre", value: 11 },
  { label: "Décembre", value: 12 },
];

// Generate years options for the past 20 years (or adjust as needed)
const currentYear = new Date().getFullYear();
const yearsOptions = Array.from({ length: 2 }, (_, i) => ({
  label: currentYear - i,
  value: currentYear - i,
}));

const KPIProduitsDetails = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const { type } = useParams();
  const pathName = location.pathname;
  const animatedComponents = makeAnimated();
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [dataByYear, setDataByYear] = useState([]);
  const pageTitle = navigationTitles[pathName] || "Default Title";
  const [yearsOptions, setYearsOptions] = useState([]);
  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();
          const currentYear = today.getFullYear();

          // Setting the selected year to the current year
          setSelectedYear({
            value: currentYear,
            label: currentYear.toString(), // converting number to string for display
          });

          const yearsOptions = response.data["success"].years.map((year, index) => ({
            value: year,
            label: year.toString(), // converting number to string for display
          }));

          setYearsOptions(yearsOptions);
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  }, []);

  useEffect(() => {
    const currentMonth = new Date().getMonth() + 1; // Months are 0-based
    setSelectedMonth(monthsOptions.find((month) => month.value === currentMonth));
  }, []);
  const handleMonthChange = (selectedOption) => setSelectedMonth(selectedOption);
  const handleYearChange = (selectedOption) => setSelectedYear(selectedOption);

  const fetchData = () => {
    if (!selectedMonth || !selectedYear) return; // Don't fetch data if month or year is not selected
    startLoading();

    KPIProduitsService.getFamilleOrSousFamilleOrCategoriesOrMarques(
      getCurrentUserId(),
      selectedMonth.value,
      selectedYear.value,
      type
    )
      .then((response) => {
        // Ensure response contains the expected data
        if (response.data && response.data.success) {
          setDataByYear(response.data.success);
        } else {
          console.log("Unexpected response structure: ", response);
        }
      })
      .catch((error) => {
        console.log("Error fetching data: ", error);
      })
      .finally(() => {
        // Always stop loading, whether it's a success or error case
        stopLoading();
      });
  };


  useEffect(() => {
    fetchData();
  }, [selectedMonth, selectedYear]);

  const onViewProductsHandler = (reference) => {
    // Implement or define a handler to navigate or fetch details
    console.log(`View products for reference: ${reference}`);
  };

  const onConfirmHandler = (id, index) => {
    // Implement or define a handler for confirming a transfer
    console.log(`Confirm transfer with id: ${id} at index: ${index}`);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>Home</Link>
                </li>
                <li className="breadcrumb-item active" style={{ color: "black" }}>
                  Les KPI de Vente
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div className="card-header">
        <h3 className="">Détails de {pageTitle}</h3>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Choisir un an et un mois</h3>
                </div>
                <div className="card-body d-flex justify-content-center align-items-center">
                  <div className="form-group col-6 col-sm-6">
                    <label>Choisir l'année</label>
                    <Select
                      value={selectedYear}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={yearsOptions}
                      onChange={handleYearChange}
                      placeholder="Sélectionner l'année"
                    />
                  </div>

                  <div className="form-group col-6 col-sm-6">
                    <label>Choisir le mois</label>
                    <Select
                      value={selectedMonth}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={monthsOptions}
                      onChange={handleMonthChange}
                      placeholder="Sélectionner le mois"
                    />
                  </div>
                </div>
              </div>

              {/* Render confirmed and inconfirmed transfers tables */}
              {dataByYear && dataByYear.length > 0 && renderTransferTable(dataByYear,`${pageTitle}`)}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(KPIProduitsDetails);
